import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: number;
  title: string;
  category: string;
  cover: string;
  rating: number;
  year: number;
  tags: string[];
  isNew?: boolean;
}

export default function MovieCard({ id, title, category, cover, rating, year, tags, isNew }: MovieCardProps) {
  return (
    <Link
      to={`/category/${category}`}
      className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

        {isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
            NEW
          </span>
        )}

        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-black/60 text-primary-300 text-xs font-semibold flex items-center gap-0.5">
          <i className="ri-star-fill text-[10px]"></i>
          {rating}
        </span>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-background-50 text-sm font-medium leading-snug truncate font-heading">
            {title}
          </h3>
          <p className="text-background-300 text-xs mt-0.5">{year}</p>
        </div>
      </div>

      <div className="p-3">
        <div className="flex items-center gap-1.5 flex-wrap">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}